import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, ArrowRight, Mail } from 'lucide-react';

const PaymentPending = () => {
  const [searchParams] = useSearchParams();
  const mpReference = searchParams.get('mp_reference');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen dark" style={{ background: 'linear-gradient(135deg, #080c2d 0%, #1a1a3e 100%)' }} data-testid="payment-pending-page">
      <div className="container mx-auto px-6 py-16 flex items-center justify-center min-h-screen">
        <Card className="card-viubux-dark border-yellow-500/20 max-w-md w-full" data-testid="payment-pending-card">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <Clock className="w-16 h-16 text-yellow-500" />
            </div>
            <CardTitle className="gotham-bold text-2xl text-white">Pago Pendiente</CardTitle>
            <CardDescription className="verdana-regular text-white/70">
              Tu pago está siendo procesado. Esto puede tomar unos minutos o hasta 72 horas dependiendo del método de pago.
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 space-y-3">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-yellow-400 mt-0.5" />
                <div>
                  <p className="text-yellow-400 text-sm font-semibold">Te notificaremos por correo</p>
                  <p className="text-white/60 text-xs">
                    Recibirás un email cuando tu pago sea confirmado y tu membresía activada.
                  </p>
                </div>
              </div>
              
              {mpReference && (
                <div className="pt-2 border-t border-yellow-500/20">
                  <p className="text-white/50 text-xs">
                    Referencia de pago: <code className="text-yellow-400">{mpReference}</code>
                  </p>
                </div>
              )}
            </div>

            <div className="bg-black/30 rounded-lg p-4">
              <h4 className="text-white font-semibold text-sm mb-2">¿Qué sigue?</h4>
              <ul className="text-white/60 text-xs space-y-1">
                <li>• Si pagaste en efectivo (OXXO, 7-Eleven), puede tomar hasta 24 horas</li>
                <li>• Los pagos con tarjeta se confirman en minutos</li>
                <li>• Tu membresía se activará automáticamente al confirmar</li>
              </ul>
            </div>

            <Button
              data-testid="go-to-dashboard-btn"
              onClick={() => navigate('/dashboard')}
              className="w-full btn-viubux flex items-center justify-center gap-2"
            >
              Ir al Dashboard
              <ArrowRight className="w-4 h-4" />
            </Button>

            <p className="text-center text-white/40 text-xs">
              ¿Dudas? Escríbenos a <strong>pagos@viubux.com</strong>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentPending;
